import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { useMarketRankingFilterOptions } from '../queries/useMarketRankingFilterOptions';
import { isNil } from 'shared/src/utils';

//1~5
export const useAgeSelectBottomSheet = createUseBottomSheetModal<
  { nextValue: number | null },
  { selected: number | null; marketTypeSno: number }
>(({ confirm, param }) => {
  const { data } = useMarketRankingFilterOptions(param.marketTypeSno);

  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      <Flex.Row
        alignItems={'center'}
        justifyContent={'space-between'}
        padding={{ horizontal: 16, vertical: 16 }}
        onPress={() => confirm({ nextValue: null })}
      >
        <Typography
          type={isNil(param.selected) ? 'subtitle1' : 'body1'}
          color={isNil(param.selected) ? 'content_pink_primary' : undefined}
        >
          전체연령
        </Typography>
        {isNil(param.selected) ? (
          <IconCheck size={20} fill={Colors.content_pink_primary} />
        ) : (
          <></>
        )}
      </Flex.Row>
      {data.ages.map(item => {
        const selected = item.value === param.selected;
        return (
          <Flex.Row
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ nextValue: item.value })}
          >
            <Typography
              type={selected ? 'subtitle1' : 'body1'}
              color={selected ? 'content_pink_primary' : undefined}
            >
              {item.name}
            </Typography>
            {selected ? (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            ) : (
              <></>
            )}
          </Flex.Row>
        );
      })}
    </BottomSheetContainer>
  );
});
